import { AccessibilityStatus, TrendDirection } from '../types';

export interface AccessibilityMetric {
	value: string;
	trend: {
		direction: TrendDirection;
		percentage: number;
	};
}

export interface AccessibilitySummaryData {
	groupedScore: {
		score: number | null;
		status: AccessibilityStatus;
	};
	uniqueIssues: {
		critical: AccessibilityMetric;
		allIssues: AccessibilityMetric;
	};
	totalIssues?: {
		critical: AccessibilityMetric;
		allIssues: AccessibilityMetric;
	};
}

const createDefaultMetric = (): AccessibilityMetric => ({
	value: '0',
	trend: {
		direction: TrendDirection.DOWN,
		percentage: 0
	}
});

export const createDefaultAccessibilitySummary = (): AccessibilitySummaryData => ({
	groupedScore: {
		score: null, // N/A when no data available
		status: AccessibilityStatus.GOOD // Default to good status for N/A
	},
	uniqueIssues: {
		critical: createDefaultMetric(),
		allIssues: createDefaultMetric()
	},
	totalIssues: {
		critical: createDefaultMetric(),
		allIssues: createDefaultMetric()
	}
});
